import React, { useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'
import Link from 'next/link'
import moment from 'moment/moment'

import { Column, Row } from '../Grid'
import { Text } from '../Text'
import { SearchPsychologistCard } from '../Cards'
import { FilledInfo } from '../Icons'
import ResultsController from '../ResultsController'
import { Button } from '../Button'
import { Loader } from '../Loader'

import { getProfile } from '../../../services/auth'

const FavoritesList = ({
  setIsLoading,
  professionalsList,
  pagingData,
  getLikeProfessional,
  handleDatesChange,
  timezoneFilter,
  startDate,
  isLoggedIn,
  handleMultipleScheduling
}) => {
  const [isLoadingButton, setIsLoadingButton] = useState(false)
  const [hasPsychologistUnavailable, setHasPsychologistUnavailable] = useState(false)

  const handlePagination = useCallback(async () => {
    try {
      setIsLoadingButton(true)
      await getLikeProfessional(pagingData.next)
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoadingButton(false)
    }
  }, [pagingData])

  const user = getProfile()

  const handleShowSearchPsychologistCard = (isLoggedIn, psychologist) => {
    if (
      !isLoggedIn ||
      !user.contract ||
      (isLoggedIn && psychologist?.is_available_by_contract) ||
      psychologist?.is_available_by_contract === null
    ) {
      return true
    }
    return false
  }
  useEffect(() => {
    setHasPsychologistUnavailable(
      professionalsList?.some(psychologist => psychologist.is_available_by_contract === false)
    )
  }, [professionalsList])

  return (
    <ResultsCards margin={['64px auto 278px', '0 auto 278px']} alignSelf='center'>
      {!isLoggedIn && (
        <Row
          background='#DDE7F2'
          borderRadius='8px'
          marginTop='23px'
          height={['136px', '80px']}
          alignItems='center'
          padding='20px'
        >
          <Row maxWidth={['24px', '40px']} maxHeight={['24px', '40px']}>
            <FilledInfo backgroundColor='#294671' color='#fff' size='100%' />
          </Row>
          <Text variant='regular' textAlign='left' marginLeft='20px' color='#294671'>
            Para ter uma melhor experiência,
            <Link href='/entrar'>
              <TextLink>faça login</TextLink>
            </Link>
            e tenha seus psicólogos favoritos salvos em todos seus dispositivos.
          </Text>
        </Row>
      )}
      <Row marginTop='10px' marginLeft={['0px', '10px']}>
        <ResultsController
          startDate={moment(startDate)}
          timezone={timezoneFilter}
          onDateChange={e => handleDatesChange(e)}
          onChangeTimezone={e => handleTimezone(e)}
        />
      </Row>
      {professionalsList?.map(psychologist => {
        const consultation = psychologist?.schedules?.some(
          schedule => schedule.prof_address === null
        )
          ? 'online'
          : 'presencial'
        return (
          handleShowSearchPsychologistCard(isLoggedIn, psychologist) && (
            <SearchPsychologistCard
              psychologist={psychologist}
              timezone={timezoneFilter}
              goToPsychologist={() => setIsLoading(true)}
              filters={{ startDate: startDate, timezone: timezoneFilter }}
              query={{ consultation: consultation }}
              key={psychologist?.id}
              handleMultipleScheduling={params => handleMultipleScheduling(params)}
              consultation={consultation}
            />
          )
        )
      })}
      {pagingData?.count > 6 && pagingData.next !== null && (
        <Row justifyContent='center'>
          <Button width='125px' onClick={handlePagination} disabled={isLoadingButton}>
            {isLoadingButton ? <Loader /> : 'Ver mais'}
          </Button>
        </Row>
      )}

      {isLoggedIn && hasPsychologistUnavailable && (
        <Row
          background='#DDE7F2'
          borderRadius='8px'
          marginTop='23px'
          height={['210px', '95px']}
          alignItems='center'
          padding='20px'
        >
          <Row maxWidth={['24px', '40px']} maxHeight={['24px', '40px']}>
            <FilledInfo backgroundColor='#294671' color='#fff' size='100%' />
          </Row>
          <Column>
            <Text variant='regular' textAlign='left' marginLeft='20px' color='#294671'>
              Alguns psicólogos que você favoritou não foram exibidos porque não estão disponíveis
              para sua parceria.
            </Text>
            <Text
              variant='regular'
              textAlign='left'
              marginLeft='20px'
              marginTop='10px'
              color='#294671'
            >
              Não se preocupe, você pode encontrar mais psicólogos para te ajudar
              <Link href='/encontre-seu-psicologo'>
                <TextLink>clicando aqui</TextLink>
              </Link>
              .
            </Text>
          </Column>
        </Row>
      )}
    </ResultsCards>
  )
}

const ResultsCards = styled(Column)`
  width: 1130px;

  @media (max-width: 425px) {
    width: 346px;
  }

  @media (max-width: 375px) {
    width: 326px;
  }

  @media (max-width: 320px) {
    width: 310px;
  }
`

const TextLink = styled.a`
  font-weight: bold;
  margin: 0 5px;
  color: #294671;
  text-decoration: underline;

  &:hover {
    color: #294671;
    text-decoration: underline;
  }
`

export { FavoritesList }
